import React, { useState, useEffect, Fragment } from "react";
import { Box, Card, Stack, responsiveFontSizes } from "@mui/material";
import { fetchRecepcion } from "verticales/FetchData";
import Tabs from "@mui/material/Tabs";
import MDBox from "components/MDBox";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CardContent from "@mui/material/CardContent";
import AppLoading from "verticales/AppLoading.tsx";
import { Label } from "recharts";
import { Backpack, FileDownload, Mail, Margin, Padding } from "@mui/icons-material";
import { json } from "react-router-dom";
import fetchData from "verticales/FetchData";

// const url = "https://292br7ikz2.execute-api.us-east-1.amazonaws.com/st-fe-recepcion/recepcion/";
// const action = "mail";
function DatosMail(props: any) {
  console.log(props);
  // console.log(props.row.original.id_mensaje);
  const [client, setclient] = useState({});
  const [Attachment, setAttachment] = useState([]);
  const [blocking, setBlocking] = React.useState(true);
  const [documentUrl, setDocumentUrls] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);

  const dataClient = async () => {
    if (props) {
      setclient(props.row);
    } else console.log("Error al renderizar");

    setBlocking(false);
  };

  useEffect(() => {
    dataClient();
  }, []);

  return (
    <DashboardLayout>
      <MDBox pt={4} pb={3} px={3} display="flex" justifyContent="center">
        <Card
          sx={{
            width: "100%",
            maxWidth: "90vw",
            maxHeight: "90vh",
            boxShadow: 3,
            borderRadius: 3,
            overflow: "auto",
            marginLeft: 4,
          }}
        >
          {blocking ? (
            <AppLoading titleCustom="Detalle cliente" />
          ) : (
            <Grid>
              <Grid item xs={12}>
                <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                  <b>Fecha:</b> <br />
                  {client?.fecha_creacion || "No disponible"}
                </MDBox>
              </Grid>

              <Grid item xs={12}>
                <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                  <b>Nit:</b> <br />
                  {client?.nit || "No disponible"}
                </MDBox>
              </Grid>

              <Grid item xs={6}>
                <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                  <b>Id:</b> <br />
                  {client?.id || "No disponible"}
                </MDBox>
              </Grid>
              <Grid item xs={6}>
                <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                  <b>Razón Social:</b> <br />
                  {client?.razon_social || "No disponible"}
                </MDBox>
              </Grid>
              <Grid item xs={12}>
                <MDBox borderRadius={2} p={2} bgcolor="grey.100">
                  <b>Ruta Bucket:</b> <br />
                  {client?.key_url_presigned || "No disponible"}
                </MDBox>
              </Grid>
            </Grid>
          )}
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default DatosMail;
